/* eslint-disable react/forbid-elements */
import { DialogActions, DialogActionsProps } from '@mui/material';
import { forwardRef, Ref } from 'react';

const ResponsiveDialogActions = forwardRef(
  ({ sx, ...props }: DialogActionsProps, ref: Ref<HTMLDivElement>) => {
    return (
      <DialogActions
        {...props}
        sx={{
          m: 2,
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          gap: 1,
          // Only override margin-left on xs
          '& > :not(:first-of-type)': {
            ml: { xs: 0, sm: 'inherit' },
          },
          '& button': {
            mt: { xs: 1, sm: 'inherit' },
            width: { xs: '100%', sm: 'inherit' },
          },
          ...sx,
        }}
      />
    );
  }
);

export default ResponsiveDialogActions;
